import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MaestrosSyncInterceptStrategy } from './auth-shared/MaestrosSyncInterceptStrategy';
import { SumaxErpInterceptStrategy } from './auth-shared/SumaxErpInterceptStrategy';
import { InterceptStrategy } from './auth-shared/InterceptStrategy';

@Injectable({ providedIn: 'root' })
export class InterceptorsStrategyService {
	strategies: InterceptStrategy[] = [
		//this.dmsInterceptStrategy,
		//this.emptyInterceptStrategy,
		this.maestrosInterceptStrategy,
		this.sumaxErpInterceptStrategy,
	];

	constructor(
		//private readonly dmsInterceptStrategy: DmsInterceptStrategy,
		//private emptyInterceptStrategy: EmptyInterceptStrategy,
		private readonly maestrosInterceptStrategy: MaestrosSyncInterceptStrategy,
		private readonly sumaxErpInterceptStrategy: SumaxErpInterceptStrategy
	) {}

	resolveStrategy(req: HttpRequest<any>): InterceptStrategy | undefined {
		return this.strategies.find((s) => s.isIntercepted(req));
	}
}
